exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "pre[data-v-2ed7d734]{white-space:break-spaces;line-break:anywhere}.examination-timer[data-v-2ed7d734]{position:absolute;right:0;top:-35px}.examination-item-questions-block[data-v-2ed7d734]{margin-bottom:18px}.examination-item-questions-input[data-v-2ed7d734]{padding-top:5px;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ed7d734","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/modules/remote-edu/examination-item/examinationItem.vue
// module id = ae1f2b1ce81195cae57f
// module chunks = 3